<template lang="pug">
.container
  .items-container
    .deviceTags.tags-used
      el-tag.tag(v-for='deviceTag in deviceTags', :key='deviceTag.id', closable, @close="handleDeleteTagFromDevice(deviceTag)", :id="'DeviceTagsEditorSimple-usedTag' + deviceTag.id")
        span.cursor-pointer(@dblclick='editNetworkTag(deviceTag)') {{ deviceTag.name }}
      p.no-tags-warning(v-if='deviceTags.length === 0') {{ $t('This device has no tags.')}}
        span(v-if='unusedNetworktagsInDevice.length > 0') &nbsp;{{ $t('Click a tag below to assign it to device.') }}
    .deviceTags
      p.no-tags-warning(v-if='this.$store.state.Device.device_tags.length === 0')
        span {{ $t('No network tags.') }}
      el-button.tag.tag-unused(v-for='unusedDeviceTag in unusedNetworktagsInDevice', :id="'DeviceTagsEditorSimple-unusedTag' + unusedDeviceTag.id", :key='unusedDeviceTag.id', @click='addTagToDevice(unusedDeviceTag)', size="small", :title='$t("Click to add tag to device")') + {{ unusedDeviceTag.name }}
      el-button(v-if='!inputVisible', size='small', @click='showInput', type='success', plain) {{$t('+ Create Tag')}}
      el-input.input-new-tag(v-if='inputVisible', v-model='addTagName', ref='saveTagInput', size='mini', @keyup.enter.native='addTag', @blur='addTag')
  el-dialog(:close-on-click-modal="false", :visible.sync='editTagFormVisible', append-to-body, @close='editTagFormVisible = false; editedTag = undefined')
    .container(v-if='editedTag')
      DeviceTagEditorGlobal(id="DeviceTagsEditorSimple-deviceTagEditorGlobal" :editedTag='editedTag', @doneEditTag='emitReloadDevice()')
</template>

<script>
import DeviceTagEditorGlobal from './DeviceTagEditorGlobal'
import deviceUtils from '../Common/deviceUtils.mixin'

export default {
  props: ['newEditedDevice'],
  mixins: [deviceUtils],
  components: {
    DeviceTagEditorGlobal
  },
  created () {
    this.device = this.$store.state.Device.device_list.find(device => {
      return device.id === this.newEditedDevice.id
    })
  },
  data () {
    return {
      errors: {
      },
      inputVisible: false,
      addTagName: '',
      editTagFormVisible: false,
      editedTag: undefined,
      savingNetworkTag: false,
      deletingNetworkTag: false,
      device: undefined
    }
  },
  methods: {
    emitReloadDevice () {
      this.$emit('reloadDevice')
    },
    editNetworkTag (tag) {
      this.editedTag = JSON.parse(JSON.stringify(tag))
      this.editTagFormVisible = true
    },
    async handleDeleteTagFromDevice (tag) {
      await this.$store.dispatch('Device/deleteDeviceTagFromDevice', [tag.id, this.device.id])
    },
    showInput () {
      this.inputVisible = true
      this.$nextTick(_ => {
        this.$refs.saveTagInput.$refs.input.focus()
      })
    },
    async addTag () {
      if (this.addTagName) {
        const tagAdded = await this.$store.dispatch('Device/addDeviceTag', this.addTagName)
        await this.$store.dispatch('Device/addDeviceTagToDevice', [tagAdded.id, this.device.id])
      }
      this.inputVisible = false
      this.addTagName = ''
    },
    async addTagToDevice (tag) {
      await this.$store.dispatch('Device/addDeviceTagToDevice', [tag.id, this.device.id])
    }
  },
  computed: {
    unusedNetworktagsInDevice () {
      if (!this.device) return this.$store.state.Device.device_tags
      const unusedTagsInDevice = []
      for (let index = 0; index < this.$store.state.Device.device_tags.length; index++) {
        const element = this.$store.state.Device.device_tags[index]
        const deviceTagUsedInDevice = this.deviceTags.findIndex(deviceTag => deviceTag.id === element.id)
        if (deviceTagUsedInDevice === -1) unusedTagsInDevice.push(element)
      }
      const allunusedTagsInDevice = JSON.parse(JSON.stringify(this.$store.state.Device.device_tags_unused))
      for (const unusedTagInDevice of unusedTagsInDevice) {
        if (!allunusedTagsInDevice.find(dt => dt.id === unusedTagInDevice.id)) {
          allunusedTagsInDevice.push(unusedTagInDevice)
        }
      }
      const tagsSorted = allunusedTagsInDevice.sort((a, b) => (a.name > b.name) ? 1 : ((b.name > a.name) ? -1 : 0))
      return tagsSorted
    },
    deviceTags () {
      if (!this.device) return []
      const tagsSorted = this.$store.state.Device.device_tags.filter(dt => dt.device.includes(this.device.id)).sort((a, b) => (a.name > b.name) ? 1 : ((b.name > a.name) ? -1 : 0))
      return tagsSorted
    }
  }
}
</script>
<style lang="scss" scoped>
@import "../../../theme-m4b/src/common/var.scss";
.items-container {
  display: flex;
  flex-direction: column;
  .deviceTagsUsed, .unusedTags {
    display: inline-flex;
    border: 0px solid red;
    flex-wrap: wrap;
    justify-content: flex-start;
    .no-tags-warning {
      margin-right: 20px;
      color: $--color-text-secondary;
    }
  }
  .deviceTags {
    border-bottom: $--border-light;
    padding: 0px 0px 0px 0px;
    margin-bottom: 10px;
    &.tags-used {
      margin-top: 10px;
    }
    .tag, button {
      margin: 0px 10px 10px 0px;
      background-color: rgba($--color-primary, 0.6);
      border: 1px solid rgba(black, 0.8);
      border-radius: 5px;
    }
    .tag-unused {
      opacity: 0.5;
      color: #fff;
    }
    button {
      margin: 0px 10px 10px 0px;
    }
    .input-new-tag {
      width: 100px;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Device/DeviceTagsEditorSimple.vue